import { Avatar } from "@mui/material";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import { getThumbnailUrl } from "../CTLLocationImageUpload/urlUtils";

// Table-cell thumbnail for Location Master's Background Image URL column — keeps the list
// fast even when the underlying uploaded image is large, by loading the thumbnail file
// instead of the full-size one.
function CTLLocationBackgroundImageCell({ value }) {
  if (!value) {
    return <ImageNotSupportedOutlinedIcon color="disabled" fontSize="small" />;
  }

  return (
    <Avatar
      variant="rounded"
      src={getThumbnailUrl(value) || value}
      sx={{ width: 32, height: 32 }}
    />
  );
}

export default CTLLocationBackgroundImageCell;
